<ng-container *ngIf="voucherModal">
  <div class="container_position">
    <div class="container_all" *ngIf="!resgateFeito">
      <div (click)="voucherModal = false" class="close_voucher">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
        >
          <path
            d="M2.43043 2.42915C2.59854 2.2611 2.82652 2.16669 3.06422 2.16669C3.30192 2.16669 3.5299 2.2611 3.698 2.42915L6.86783 5.59897L10.0376 2.42915C10.2067 2.26586 10.4332 2.1755 10.6682 2.17755C10.9032 2.17959 11.1281 2.27387 11.2943 2.44007C11.4605 2.60628 11.5548 2.83112 11.5568 3.06616C11.5589 3.30121 11.4685 3.52765 11.3052 3.69672L8.1354 6.86654L11.3052 10.0364C11.4685 10.2054 11.5589 10.4319 11.5568 10.6669C11.5548 10.902 11.4605 11.1268 11.2943 11.293C11.1281 11.4592 10.9032 11.5535 10.6682 11.5555C10.4332 11.5576 10.2067 11.4672 10.0376 11.3039L6.86783 8.13411L3.698 11.3039C3.52893 11.4672 3.30249 11.5576 3.06745 11.5555C2.8324 11.5535 2.60756 11.4592 2.44135 11.293C2.27515 11.1268 2.18087 10.902 2.17883 10.6669C2.17678 10.4319 2.26714 10.2054 2.43043 10.0364L5.60026 6.86654L2.43043 3.69672C2.26238 3.52862 2.16797 3.30064 2.16797 3.06294C2.16797 2.82523 2.26238 2.59726 2.43043 2.42915Z"
            fill="white"
          />
        </svg>
      </div>
      <div class="content">
        <h1 class="title">Resgate recompensas!</h1>
        <p class="p_code">
          Hey, Lover!
          <br />
          <br />
          Recebeu um voucher ?
          <br />
          <br />
          Insira o código abaixo para resgatar sua recompensa:
        </p>
        <div
          class="input_code_div"
          [ngStyle]="
            voucherJaUtilizado || (errorVoucher && { 'border-color': 'red' })
          "
        >
          <input
            class="input_code"
            [(ngModel)]="voucher"
            placeholder="Digite o código (ex: 12BW35)"
            type="text"
          />
        </div>
        <p class="input_error" *ngIf="voucherJaUtilizado || errorVoucher">
          {{ errorVoucher }}
        </p>
        <button
          [ngClass]="{ carregando: carregandoVoucher }"
          class="btn"
          (click)="buscaVoucher()"
        >
          Resgatar recompensa
          <i *ngIf="carregandoVoucher" class="fa fa-spinner fa-spin"></i>
        </button>
      </div>
      <p class="error">
        Caso esteja com algum problema entre em contato com o SAC via telefone:
        4004-2987 (capitais e região metropolitana) ou 0800 119263 (demais
        regiões) - horário de atendimento: segunda a sexta-feira das 08:00 às
        17:00 e aos sábados das 08:00 às 16:00.
      </p>
    </div>
  </div>
  <div class="overlay"></div>
</ng-container>

<!-- Regulamento -->
<lovers-popup
  [exibir]="exibirModalRegulamento"
  (onClose)="exibirModalRegulamento = false; voucherModal = false"
>
  <div class="popup__header">
    <p class="header__title">Promoção Palito Premiado</p>
  </div>
  <div class="popup__body">
    <p class="regulamento__titulo">Confira o regulamento e participe!</p>
    <div class="regulamento__texto regulamento__container">
      <p *ngFor="let paragrafo of regulamento">
        {{ paragrafo }}
      </p>
    </div>
  </div>
</lovers-popup>

<!-- Resgate de cacaus -->

<lovers-popup
  [exibir]="exibirPopupResgateCacaus"
  (onClose)="exibirPopupResgateCacaus = false; cacaus = 0; voucherModal = false"
  tamanho="pequeno2"
>
  <div class="popup__header__resgate">
    <img
      class="moeda__cacau"
      src="assets/images/palito-premiado/moeda_cacau.svg"
      alt="Moeda Cacau Lovers"
      title="Moeda Cacau Lovers"
    />
    <p class="header__title">Parabéns! Você ganhou +{{ cacaus }} cacaus!</p>
  </div>
  <div class="popup__body__resgate">
    <p class="regulamento__titulo">
      {{
        voucherLinkeMess?.mensagemResgate ??
          "Você resgatou sua recompensa! Aproveite para resgatar mais momentos especiais."
      }}
    </p>
  </div>
  <button (click)="irParaMomentosEspeciais()" class="momento__resgatado">
    Resgatar
  </button>
</lovers-popup>

<!-- Resgate de pontos -->

<lovers-popup
  [exibir]="exibirPopupResgatePontos"
  (onClose)="exibirPopupResgateCacaus = false; pontos = 0; voucherModal = false"
  tamanho="pequeno2"
>
  <div class="popup__header__resgate">
    <img
      class="pontos__cacau"
      src="assets/images/palito-premiado/pontos.svg"
      alt="Moeda Cacau Lovers"
      title="Moeda Cacau Lovers"
    />
    <p class="header__title">Você ganhou +{{ pontos }} pontos!</p>
  </div>
  <div class="popup__body__resgate">
    <p class="regulamento__titulo">
      Parabéns, você resgatou sua recompensa! Agora nosso relacionamento está
      ainda mais forte.
    </p>
  </div>
  <button (click)="irParaMomentosEspeciais()" class="momento__resgatado">
    Resgatar Momentos Especiais
  </button>
</lovers-popup>

<!-- Resgate de promoção -->

<lovers-popup
  [exibir]="exibirPopupResgatePromocao"
  (onClose)="
    exibirPopupResgatePromocao = false; promocao = null; voucherModal = false
  "
  tamanho="pequeno2"
>
  <div class="popup__header__resgate">
    <p class="header__title">
      Você resgatou a promoção {{ promocaoModel?.descricao }}
    </p>
  </div>
  <div class="popup__body__resgate">
    <p class="regulamento__titulo">
      {{
        voucherLinkeMess?.mensagemResgate !== ""
          ? voucherLinkeMess?.mensagemResgate
          : "Uau! Parabéns, você resgatou sua recompensa!"
      }}
    </p>

    <p class="regulamento__titulo" *ngIf="quantidadePromocoesUsuarios != null">
      Você tem direito a {{ quantidadePromocoesUsuarios }} resgates
    </p>
  </div>
  <button (click)="irParaMeusMomentos()" class="momento__resgatado">
    Ir para Meus Momentos
  </button>
</lovers-popup>

<!-- Resgate de experiência -->

<lovers-popup
  [exibir]="exibirPopupResgateExperiencia"
  (onClose)="
    exibirPopupResgateExperiencia = false;
    experiencia = null;
    voucherModal = false
  "
  tamanho="pequeno2"
>
  <img
    class="experincia_icone"
    src="assets/images/icons/icone_resgate_experiencia.png"
    alt="Presente Resgate"
    title="Presente Resgate"
  />

  <div class="popup__header__resgate">
    <p
      class="header__title"
      [innerHTML]="voucherLinkeMess?.mensagemResgate ?? 'Recompensa resgatada!'"
    ></p>
  </div>

  <div class="popup__body__resgate" *ngIf="!voucherLinkeMess?.mensagemResgate">
    <p class="regulamento__titulo">
      Você resgatou {{ experienciaModel?.nome }}
    </p>
  </div>

  <button (click)="irParaMeusMomentos()" class="momento__resgatado">
    Meus Momentos
  </button>
</lovers-popup>
